import React from 'react';
import Icon from '../../../components/AppIcon';

const FormHeader = ({
  currentStep = 1,
  totalSteps = 3,
  estimatedTime = '۵-۱۰ دقیقه',
}) => {
  const progressPercentage = (currentStep / totalSteps) * 100;

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h1 className="text-2xl font-bold text-foreground mb-2">
            درخواست سند حقوقی جدید
          </h1>
          <p className="text-muted-foreground">
            فرم زیر را با دقت تکمیل کنید تا بتوانیم بهترین سند حقوقی را برای شما
            تهیه کنیم
          </p>
        </div>
        <div className="flex items-center space-x-2 space-x-reverse text-sm text-muted-foreground">
          <Icon name="Clock" size={16} />
          <span>زمان تقریبی: {estimatedTime}</span>
        </div>
      </div>

      {/* Progress Bar */}
      <div className="space-y-2">
        <div className="flex justify-between text-sm">
          <span className="text-muted-foreground">پیشرفت تکمیل فرم</span>
          <span className="text-foreground font-medium">
            {Math.round(progressPercentage)}%
          </span>
        </div>
        <div className="w-full bg-muted rounded-full h-2">
          <div
            className="bg-primary h-2 rounded-full transition-all duration-300 ease-out"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      </div>

      {/* Step Indicators */}
      <div className="flex items-center justify-center mt-4 space-x-4 space-x-reverse">
        {Array.from({ length: totalSteps }, (_, index) => {
          const stepNumber = index + 1;
          const isActive = stepNumber === currentStep;
          const isCompleted = stepNumber < currentStep;

          return (
            <div key={stepNumber} className="flex items-center">
              <div
                className={`
                w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-all duration-150
                ${
                  isCompleted
                    ? 'bg-success text-success-foreground'
                    : isActive
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-muted text-muted-foreground'
                }
              `}>
                {isCompleted ? <Icon name="Check" size={16} /> : stepNumber}
              </div>
              {stepNumber < totalSteps && (
                <div
                  className={`
                  w-8 h-0.5 mx-2 transition-all duration-150
                  ${stepNumber < currentStep ? 'bg-success' : 'bg-muted'}
                `}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FormHeader;
